import React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from 'react-admin';

export const SupplementCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="name" validate={[required()]} label="Название" />
        <TextInput source="subtitle" validate={[required()]} label="Подзаголовок" />
        <TextInput source="description" multiline rows={4} validate={[required()]} label="Описание" />
        <TextInput source="emoji" label="Эмодзи" defaultValue="💊" />
        <TextInput source="color" label="Цвет (hex код)" placeholder="#1976d2" defaultValue="#1976d2" />
        <NumberInput source="price" step={0.01} validate={[required()]} label="Цена ($)" />
        <TextInput source="duration" validate={[required()]} label="Длительность приема" defaultValue="30 дней" />
        <BooleanInput source="isActive" label="Активна" defaultValue={true} />
      </FormTab>

      <FormTab label="Преимущества">
        <ArrayInput source="benefits" label="Преимущества">
          <SimpleFormIterator>
            <TextInput source="" label="Преимущество" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Состав">
        <ArrayInput source="composition" label="Состав">
          <SimpleFormIterator>
            <TextInput source="name" label="Название компонента" validate={[required()]} />
            <TextInput source="dosage" label="Дозировка" validate={[required()]} />
            <TextInput source="description" label="Описание" multiline rows={2} />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Рекомендации">
        <ArrayInput source="targetChallenges" label="Целевые челленджи">
          <SimpleFormIterator>
            <TextInput source="" label="Тип челленджа" />
          </SimpleFormIterator>
        </ArrayInput>
        
        {/* Рекомендуемое время приема */}
        <div style={{ marginTop: '20px' }}>
          <h3>Рекомендуемое время приема</h3>
          <TextInput source="recommendedTiming.day" label="Время дня" defaultValue="Утром" />
          <ArrayInput source="recommendedTiming.symptoms" label="Симптомы">
            <SimpleFormIterator>
              <TextInput source="" label="Симптом" />
            </SimpleFormIterator>
          </ArrayInput>
        </div>
      </FormTab>
    </TabbedForm>
  </Create>
);
